import { render } from "./Buyers.vue?vue&type=template&id=26468648&scoped=true"
import script from "./Buyers.vue?vue&type=script&lang=js"
export * from "./Buyers.vue?vue&type=script&lang=js"

import "./Buyers.vue?vue&type=style&index=0&id=26468648&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26468648"],['__file',"src/views/Buyback/Buyers.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26468648"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26468648', __exports__)) {
    api.reload('26468648', __exports__)
  }
  
  module.hot.accept("./Buyers.vue?vue&type=template&id=26468648&scoped=true", () => {
    api.rerender('26468648', render)
  })

}


export default __exports__